import { ExtractionCategory, MatchRequirement } from 'dashboard/components/ExtractionPanel/util';
import { ExtractorType } from 'dashboard/models/document';

export const EXTRACTOR_TYPE_TO_DISPLAY_NAME: Record<ExtractorType, string> = {
  [ExtractorType.Text]: 'Text',
  [ExtractorType.Regex]: 'Regex',
  [ExtractorType.Preset]: 'Preset',
  [ExtractorType.KeyValuePair]: 'Key-Value Pair',
  [ExtractorType.Paystub]: 'Paystub',
  [ExtractorType.Tables]: 'Tables',
  [ExtractorType.Ai]: 'AI',
  [ExtractorType.BankStatement]: 'Bank Statement',
  [ExtractorType.InquiryFieldComparison]: 'Inquiry Comparison',
  [ExtractorType.TransactionFieldComparison]: 'Transaction Comparison',
};

export const EXTRACTOR_TYPE_TO_DESCRIPTION: Record<ExtractorType, string> = {
  [ExtractorType.Text]: 'Search for a specific string',
  [ExtractorType.Regex]: 'Use regular expression to search for a specific text pattern',
  [ExtractorType.Preset]: 'DEPRECATED',
  [ExtractorType.KeyValuePair]: 'Scan for keys and values that are adjacent',
  [ExtractorType.Paystub]: 'DEPRECATED',
  [ExtractorType.Tables]: 'DEPRECATED',
  [ExtractorType.Ai]: 'Scan using LLMs',
  [ExtractorType.BankStatement]: 'DEPRECATED',
  [ExtractorType.InquiryFieldComparison]: 'Extract & compare inquiry field values',
  [ExtractorType.TransactionFieldComparison]: 'Extract & compare transaction field values',
};

export const EXTERNALLY_CONFIGURABLE_EXTRACTOR_TYPES = [
  ExtractorType.InquiryFieldComparison,
  ExtractorType.TransactionFieldComparison,
  ExtractorType.Ai,
];

export const INTERNALLY_CONFIGURABLE_EXTRACTOR_TYPES = [
  ...EXTERNALLY_CONFIGURABLE_EXTRACTOR_TYPES,
  ExtractorType.Text,
  ExtractorType.Regex,
  ExtractorType.KeyValuePair,
];

export const EXTRACTION_CATEGORY_TO_DESCRIPTION: Record<ExtractionCategory, string> = {
  [ExtractionCategory.Address]: 'Map inquiry fields to an address schema',
  [ExtractionCategory.Name]: 'Map inquiry fields to a name schema',
};

export const MATCH_REQUIREMENT_TO_DISPLAY_NAME: Record<MatchRequirement, string> = {
  [MatchRequirement.Strict]: 'Strict',
  [MatchRequirement.Loose]: 'Loose',
  [MatchRequirement.LooseAi]: 'Loose (with AI)',
};

export const MATCH_REQUIREMENT_TO_DESCRIPTION: Record<MatchRequirement, string> = {
  [MatchRequirement.Strict]:
    'Requires a strict match with the provided field; tolerates minor OCR errors to account for common discrepancies.',
  [MatchRequirement.Loose]:
    'Allows up to 30% deviation with the provided field; suitable for cases in which slight variations are acceptable.',
  [MatchRequirement.LooseAi]:
    'Leverages AI to allow flexible matching, accounting for reasonable differences between the extracted and expected text.',
};
